import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DataTable } from '@3plearning/react-components';
import cloneDeep from 'lodash/cloneDeep';
import {
    STRENGTH_TAB,
    TITLE
} from '../../common/strength-and-weaknesses-constants';
import StrengthWeaknessTab from '../../../../components/strength-weakness-tab/strength-weakness-tab';
import { translate } from '../../../../helpers/locale-helpers';

/**
 * Displays Strengths & Weaknesses tabs and tables for classes or year groups
 * Used in All Classes view and in all admin views (All Years, One Year All Teachers, etc.)
 */
class AllClassesStrengthWeakness extends PureComponent {
    static propTypes = {
        tableConfig: PropTypes.object,
        strengths: PropTypes.array,
        weaknesses: PropTypes.array
    };

    constructor(props) {
        super(props);
        this.state = {
            currentTab: STRENGTH_TAB,
            tableConfig: this.getTableConfig(
                STRENGTH_TAB,
                this.props.tableConfig
            )
        };
        this.i18n = window.i18n;
    }

    componentWillReceiveProps(newProps) {
        if (this.props.tableConfig !== newProps.tableConfig) {
            this.setState((prevState) => ({
                tableConfig: this.getTableConfig(
                    prevState.currentTab,
                    newProps.tableConfig
                )
            }));
        }
    }

    getTableConfig = (selectedTab, tableConfig) => {
        const config = cloneDeep(tableConfig);
        config.cols.find((col) => col.id === TITLE).name =
            selectedTab === STRENGTH_TAB
                ? translate('Label - RelativeStrengths')
                : translate('Label - RelativeWeaknesses');
        return config;
    };

    tabClicked = (tab) => {
        this.setState({
            currentTab: tab,
            tableConfig: this.getTableConfig(tab, this.props.tableConfig)
        });
    };

    render() {
        const { currentTab, tableConfig } = this.state;
        const { strengths, weaknesses } = this.props;
        const isStrengthTab = currentTab === STRENGTH_TAB;
        return (
            <StrengthWeaknessTab
                isStrengthTab={isStrengthTab}
                onTabClick={this.tabClicked}
            >
                <DataTable
                    config={tableConfig}
                    data={isStrengthTab ? strengths : weaknesses}
                />
            </StrengthWeaknessTab>
        );
    }
}

export default AllClassesStrengthWeakness;



// WEBPACK FOOTER //
// ./containers/activity-mastery/all-classes/all-classes-strength-weakness/all-classes-strength-weakness.js